import CustomerInvoices from '@/components/global-admin/CustomerInvoices';

export default function InvoicesPage() {
  return (
    <div className="space-y-6 p-6" data-testid="invoices-page">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Customer invoices</h1>
        <p className="text-muted-foreground">What BitSwan has invoiced, what is paid, and what is still owed.</p>
      </div>
      <CustomerInvoices />
    </div>
  );
}
